export const textinputMaxLength = 60;
export const textareaMaxLength = 1500;
export const defaultReservedCharacters = '(){{}}&*;<>$"“”[[]]';
export const applicationName = 'CSC Form';
